import { prefixObjectValues } from '../utils';

const typeAndCategory = {
  title: 'title',
  button: 'button',
  backButton: 'back-button',
  loadingBar: 'loading-bar',
};

export default prefixObjectValues(typeAndCategory, 'registration-completed');
